var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllust2Logos = function SvgIllust2Logos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 60,
    fill: "none",
    viewBox: "0 0 109 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 0.5,
    fill: "#FFE134",
    rx: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#391B1B",
    d: "M30.5 17.5c-8.284 0-15 5.297-15 11.832 0 4.253 2.845 7.981 7.115 10.066a700 700 0 0 0-1.3 4.89c-.203.815.298.804.629.585.258-.171 4.11-2.785 5.772-3.912.922.136 1.853.204 2.785.204 8.283 0 14.999-5.298 14.999-11.832 0-6.533-6.716-11.831-15-11.831"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 48.5,
    fill: "#00C73C",
    rx: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.74 18.333v11.764L74.3 18.333h-9.134v23.333h9.093V29.902l8.44 11.764h9.134V18.333z"
  })));
};
export default SvgIllust2Logos;